import { InnerContentItem } from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";

export function SocialSecurityNumberInputSummaryField({
  field,
}: {
  field: components["schemas"]["SocialSecurityNumberCheckField"];
}) {
  return (
    <InnerContentItem testID="ssn-summary-number">{`*****${field.value.substring(
      5
    )}`}</InnerContentItem>
  );
}
